<template>
  <div class="container max-w-6xl mx-auto p-8">
    <slot />
  </div>
</template>

<script src="./container.component.ts" lang="ts" />
